import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import { useRecoilState, } from 'recoil';
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";
import { popupCustomerFlowAtom, popupExchangeBetweenBankAccountAtom, popupTransactionHistoryAtom } from '../../state';
import { FILTER_TRANSACTION_HISTORY_GROUP, MONEY_TYPE } from "../../utils/Utils";

const MONEY_TYPE_OPTIONS = Object.keys(MONEY_TYPE).map((c) => ({
  label: MONEY_TYPE[c],
  value: c,
}));




const FILTER_TRANSACTION_HISTORY_GROUP_OPTIONS = Object.keys(FILTER_TRANSACTION_HISTORY_GROUP).map((c) => ({
  label: FILTER_TRANSACTION_HISTORY_GROUP[c],
  value: c,
}));

const ReportTransactionHistory = () => {
  const printRef = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [popupTransactionHistory, setPopupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupCustomerFlow, setPopupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);
  const [popupExchangeBetweenBankAccount, setPopupExchangeBetweenBankAccount] = useRecoilState(popupExchangeBetweenBankAccountAtom);

  const history = useHistory();
  const clearPagi = useRef();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    isDelete: false,
  });


  const [loading, setLoading] = useState(false);
  const [onSearchText, setSearchText] = useState(searchParams.get('onSearchText') || "");
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState(moment().valueOf());
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [bankAccountOptions, setBankAccountOptions] = useState([]);
  const [updatedAt, setUpdatedAt] = useState(moment().valueOf());
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    bankAccountId: searchParams.get('bankAccountId') || undefined,
    categoryId: searchParams.get('categoryId') || undefined,
    type: searchParams.get('type') || undefined,
    group: searchParams.get('group') || undefined
  });

  const colTable = [
    {
      Header: "Mã",
      accessor: (item) => item?.id,
    },
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },

    {
      Header: "KH/NCC",
      accessor: (item) => item?.customer?.name
    },
    {
      Header: "Nội dung",
      accessor: (item) => item?.content || "",
    },
    {
      Header: "Danh mục",
      accessor: (item) => item?.category?.name || "",
    },
    {
      Header: "Quỹ tài khoản",
      accessor: (item) => item?.bankAccount?.name || "",
    },
    {
      Header: "Tiền thu(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền chi(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Người nhận",
      accessor: (item) => item?.receiver || "",
    },
    {
      Header: "Hợp đồng",
      accessor: (item) => item?.contractId || "",
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        if (item.customerId) {
                          setPopupCustomerFlow({
                            show: true,
                            data: {
                              id: '',
                              type: '',
                              transactionId: item.id,
                            }
                          })
                        } else {
                          setPopupTransactionHistory({
                            show: true,
                            data: {
                              id: item.id,
                              type: item.type
                            }
                          })
                        }

                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    GET("/category", {}, true).then(({ data }) => {
      setCategoryOptions([
        ...data?.map((c) => ({
          label: `${c.name}${c.type === 'IN' ? '(Nhập)' : '(Xuất)'}`,
          value: c.id,
        })),
      ]);
    });

    GET("/bank-account", {}, true).then(({ data }) => {
      setBankAccountOptions([
        ...data?.map((c) => ({
          label: `${c.name}`,
          value: c.id,
          data: c,
        })),
      ]);
    });
  }, []);


  const exportExcel = () => {
    const params = new URLSearchParams({
      start: moment(rangeDate.start).format("YYYY-MM-DD"),
      end: moment(rangeDate.end).format("YYYY-MM-DD"),
      ...(onSearchText ? { onSearchText } : {}),
      ...(filter.bankAccountId ? { bankAccountId: filter.bankAccountId } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.group ? { group: filter.group } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/transaction-history/report-transactions-bank-accounts-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(onSearchText ? { onSearchText } : {}),
      ...(filter.bankAccountId ? { bankAccountId: filter.bankAccountId } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.group ? { group: filter.group } : {}),

    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        ...(filter.bankAccountId ? { bankAccountId: filter.bankAccountId } : {}),
        ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
        ...(filter.type ? { type: filter.type } : {}),
        ...(filter.group ? { group: filter.group } : {}),
        start: moment(rangeDate.start).format('YYYY-MM-DD'),
        end: moment(rangeDate.end).format('YYYY-MM-DD'),
      };
      if (onSearchText !== "") {
        params.search = onSearchText;
      }

      GET(`transaction-history`, params, true)
        .then(({ data }) => {
          setData([...data?.rows]);
          setSummary({
            ...data.summary,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [onSearchText, timeNow, filter, updatedAt, popupTransactionHistory.updatedAt, popupCustomerFlow.updatedAt, popupExchangeBetweenBankAccount.updatedAt]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setSearchText("");
    setTimeNow(moment().valueOf());
  };



  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ isDelete: false });
  };


  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`transaction-history/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa giao dịch thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({ start: start ? moment(start)?.startOf('days').toDate() : start, end: end ? moment(end)?.endOf('days').toDate() : end });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap mw-150px"
                      >
                        <DatePicker
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          dateFormat={'dd/MM/yy'}
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          endDate={rangeDate.end}
                          onChange={onRangeChange}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>

                    </li>
                    <li>
                      <div
                        className="form-control-wrap mw-150px"
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Lọc quỹ tài khoản"
                          classNamePrefix="form-control"
                          options={bankAccountOptions}
                          value={bankAccountOptions.find(
                            (c) => c.value === filter.bankAccountId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              bankAccountId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap mw-150px"
                      >
                        <ReactSelect
                          classNamePrefix="form-control"
                          isClearable
                          placeholder="Lọc loại tiền"
                          options={MONEY_TYPE_OPTIONS}
                          value={MONEY_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap mw-150px"
                      >
                        <ReactSelect
                          classNamePrefix="form-control"
                          isClearable
                          placeholder="Lọc danh mục"
                          options={categoryOptions}
                          value={categoryOptions.find(
                            (c) => c.value === filter.categoryId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              categoryId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap mw-150px"
                      >
                        <ReactSelect
                          classNamePrefix="form-control"
                          isClearable
                          placeholder="Lọc nhóm"
                          options={FILTER_TRANSACTION_HISTORY_GROUP_OPTIONS}
                          value={FILTER_TRANSACTION_HISTORY_GROUP_OPTIONS.find(
                            (c) => c.value === filter.group
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              group: val?.value || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap mw-150px">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          placeholder="Tìm kiếm giao dịch"
                          className="form-control  border-primary"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>

                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">


                    <li>
                      <div className="form-control-wrap mw-150px">
                        <ReactToPrint
                          trigger={() => <Button className={'btn btn-secondary'}>In</Button>}
                          content={() => printRef.current}
                        />
                        <Button onClick={exportExcel} className="btn btn-secondary ml-3">
                          Xuất excel
                        </Button>

                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap mw-150px">
                        <Button
                          className={'btn btn-primary'}
                          onClick={(e) => {
                            e.preventDefault();
                            setPopupExchangeBetweenBankAccount({
                              ...popupExchangeBetweenBankAccount,
                              show: true,
                              data: {
                                id: 'add',
                              },
                            })
                          }}
                        >
                          <span>Chuyển TK khác</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center">BÁO CÁO CHI TIẾT THU CHI</h5>
                  <h6 className="text-center">Từ ngày {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')}</h6>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={<tr className="nk-tb-item odd font-weight-bold">
                      <td colSpan={6} className="nk-tb-col">
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.totalAmountIn}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col text-right" >
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.totalAmountOut}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td colSpan={1} className="nk-tb-col">
                        <span> Tổng cộng</span>
                      </td>
                      <td className="nk-tb-col text-right" colSpan={2}>
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.totalAmount}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá giao dịch này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default ReportTransactionHistory;
